/* eslint-disable class-methods-use-this */
export default class TeiResponse {
  hasResponses() {
    throw new Error('hasResponses() must be implemented in sub stype');
  }

  toJSON() {
    throw new Error('toJSON() must be implemented in sub stype');
  }

  static fromJSON() {
    throw new Error('fromJSON() must be implemented in sub stype');
  }
}
